export const FILTER_TYPES = {
  COIN_RANGE: 'coinRange',
  LOCATION: 'location',
  OFFER_STATUS: 'offerStatus',
  CHECKBOX: 'checkBox',
} as const
